import React from 'react';
import type {ManageRosterContextValue} from 'client/TeacherDashboard/ClassDetail/People/usePeopleRoster';

export type {ManageRosterContextValue};

/** Roster state shared by every ManageRoster provider. Readers always render under one. */
const ManageRosterContext = React.createContext<ManageRosterContextValue>(
  null as unknown as ManageRosterContextValue
);

export default ManageRosterContext;
